<app-pageheader [Parent]="this">
  <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
  </app-form-save-button>
</app-pageheader>

<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <div class="columns">
      <div class="column is-6">
        <!-- User Selection (only for new officers) -->
        @if (isNewRecord()) {
          <article class="panel">
            <p class="panel-heading">
              <span class="icon"><i class="fas fa-user"></i></span>
              <span>User Selection</span>
            </p>
            <div class="panel-block is-block">
              <!-- Radio buttons for creation mode -->
              <div class="field">
                <div class="control">
                  <label class="radio">
                    <input type="radio" name="userCreationMode" value="existing"
                      [(ngModel)]="userCreationMode" [ngModelOptions]="{standalone: true}"
                      (change)="onUserCreationModeChange()">
                      Select Existing User
                    </label>
                    <label class="radio ml-4">
                      <input type="radio" name="userCreationMode" value="new"
                        [(ngModel)]="userCreationMode" [ngModelOptions]="{standalone: true}"
                        (change)="onUserCreationModeChange()">
                        Create New User
                      </label>
                    </div>
                  </div>
                  <!-- Existing User Selection -->
                  @if (userCreationMode === 'existing') {
                    <div class="mt-4">
                      <app-field Label="Select User">
                        <app-singleuserselector
                          formControlName="UserId"
                          [User]="selectedUser"
                          (UserIdChange)="onUserSelected($event)"
                          (UserCleared)="onUserCleared()">
                        </app-singleuserselector>
                      </app-field>
                    </div>
                  }
                  <!-- New User Creation -->
                  @if (userCreationMode === 'new') {
                    <div class="mt-4">
                      <app-field Label="Email *">
                        <div class="control">
                          <input formControlName="Email" class="input" type="email" placeholder="user@example.com" />
                          <app-validator [For]="Form.get('Email')"></app-validator>
                        </div>
                      </app-field>
                      <app-field Label="First Name *">
                        <div class="control">
                          <input formControlName="FirstName" class="input" type="text" />
                          <app-validator [For]="Form.get('FirstName')"></app-validator>
                        </div>
                      </app-field>
                      <app-field Label="Last Name *">
                        <div class="control">
                          <input formControlName="LastName" class="input" type="text" />
                          <app-validator [For]="Form.get('LastName')"></app-validator>
                        </div>
                      </app-field>
                      <div class="notification is-info is-light mt-3">
                        <span class="icon"><i class="fas fa-info-circle"></i></span>
                        <span>A new user will be created and they will receive an email to set their password.</span>
                      </div>
                    </div>
                  }
                </div>
              </article>
            }
            <!-- Officer Details -->
            <article class="panel">
              <p class="panel-heading">
                <span class="icon"><i class="fas fa-user-shield"></i></span>
                <span>Officer Details</span>
              </p>
              <div class="panel-block is-block">
                <app-field Label="Badge Number">
                  <div class="control">
                    <input formControlName="BadgeNumber" class="input" type="text" placeholder="Optional badge identifier" />
                  </div>
                </app-field>
                <div class="field">
                  <label class="checkbox">
                    <input type="checkbox" formControlName="IsActive" />
                    Active
                  </label>
                  <p class="help">Inactive officers cannot issue citations</p>
                </div>
                <app-field Label="Notes">
                  <div class="control">
                    <textarea formControlName="Notes" class="textarea" rows="4" placeholder="Optional notes about this officer"></textarea>
                  </div>
                </app-field>
              </div>
            </article>
          </div>
        </div>
      </div>
    }


